import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Flip } from 'gsap/Flip';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(
  ScrollTrigger,
  Flip,
  MotionPathPlugin,
  DrawSVGPlugin,
  MorphSVGPlugin,
  useGSAP
);

gsap.defaults({
  duration: 0.6,
  ease: 'power2.out',
});

ScrollTrigger.defaults({
  toggleActions: 'play none none none',
  start: 'top 85%',
});

export const FADE_UP = {
  autoAlpha: 0,
  y: 30,
  duration: 0.7,
  ease: 'power2.out',
} as const;

export const FADE_DOWN = {
  autoAlpha: 0,
  y: -20,
  duration: 0.5,
  ease: 'power2.out',
} as const;

export const SCALE_IN = {
  autoAlpha: 0,
  scale: 0.85,
  duration: 0.8,
  ease: 'power3.out',
} as const;

export const STAGGER_GRID = {
  each: 0.1,
  from: 'start' as const,
  ease: 'power2.out',
};

export const MEDIA_QUERIES = {
  isDesktop: '(min-width: 1024px)',
  isTablet: '(min-width: 768px) and (max-width: 1023px)',
  isMobile: '(max-width: 767px)',
  reduceMotion: '(prefers-reduced-motion: reduce)',
} as const;

export function getMotionDuration(
  duration: number,
  reduceMotion: boolean
): number {
  return reduceMotion ? 0 : duration;
}

export {
  gsap,
  ScrollTrigger,
  Flip,
  MotionPathPlugin,
  DrawSVGPlugin,
  MorphSVGPlugin,
  useGSAP,
};
